/* eslint-disable react/no-array-index-key */
import React, {
  Fragment, useEffect, useState, useRef,
} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Select, notification,
} from 'antd';
import H3Text from '@Uilib/h3Text';
import TagActions from '@Actions/tagActions';
import './style.scss';
import PRZSelect from '../../UI/PRZSelect';

const { Option } = Select;

const TagSelector = ({
  loading, onChange, disabled, title, hideTitle, containerClassName, inputClassName, entityType, labelClassName, customStyle, selectedTags, isMultiple, createTagLoading, getTagsSOLoading, getTags, createTag, getTagsInvoiceLoading, tagsSO, tagsInvoice, entityId,
  filter, isForm, containerWrapper, tagsPO, getTagsPOLoading, tagsGRN, getTagsGRNLoading, maxTagCount, getTagsPRLoading, tagsPR, tagsPI, getTagsPILoading, hideCSS, apInvoiceLoading, apInvoice,
}) => {
  const [newTagName, setNewTagName] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [call, setCall] = useState(false);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      getTags(entityType, 1, 100, searchKeyword, () => { });
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [searchKeyword]);

  useEffect(() => {
    getTags(entityType, 1, 100, '', () => { });
  }, [call]);

  const getDataSource = () => {
    if (entityType === 'SALES_ORDER') {
      const tags = tagsSO;
      return tags;
    }
    if (entityType === 'INVOICE') {
      const tags = tagsInvoice;
      return tags;
    }
    if (entityType === 'PURCHASE_ORDER') {
      const tags = tagsPO;
      return tags;
    }
    if (entityType === 'GRN') {
      const tags = tagsGRN;
      return tags;
    }
    if (entityType === 'PURCHASE_REQUISITION') {
      const tags = tagsPR;
      return tags;
    }
    if (entityType === 'PURCHASE_INDENT') {
      const tags = tagsPI;
      return tags;
    }
    if (entityType === 'ACCOUNT_PAYABLE_INVOICE') {
      const tags = apInvoice;
      return tags;
    }
    return {};
  };

  const getDataSourceLoading = () => {
    if (entityType === 'SALES_ORDER') {
      const getTagsLoading = getTagsSOLoading;
      return getTagsLoading;
    }
    if (entityType === 'INVOICE') {
      const getTagsLoading = getTagsInvoiceLoading;
      return getTagsLoading;
    }
    if (entityType === 'PURCHASE_ORDER') {
      const getTagsLoading = getTagsPOLoading;
      return getTagsLoading;
    }
    if (entityType === 'GRN') {
      const getTagsLoading = getTagsGRNLoading;
      return getTagsLoading;
    }
    if (entityType === 'PURCHASE_REQUISITION') {
      const getTagsLoading = getTagsPRLoading;
      return getTagsLoading;
    }
    if (entityType === 'PURCHASE_INDENT') {
      const getTagsLoading = getTagsPILoading;
      return getTagsLoading;
    }
    if (entityType === 'ACCOUNT_PAYABLE_INVOICE') {
      const tags = apInvoiceLoading;
      return tags;
    }
    return true;
  };

  const handleOnTagChange = (tagAction, tagName) => {
    const tagPayload = {
      entity_name: entityType,
      entity_id: entityId,
      action: tagAction,
      tag: tagName,
    };
    createTag(tagPayload, (createdTags) => {
      getTags(entityType, 1, 10, null, () => {
      });
      setNewTagName('');
      setSearchKeyword('');
      onChange(createdTags);
    });
  };

  return (
    <Fragment>
      {filter ? (
        <div className={`filter-add-tags__wrapper ${containerClassName}`}>
          {!hideTitle ? (
            <label className={labelClassName || 'orgFormLabel'}>
              {title || 'Labels'}
              <span style={{ color: 'red' }}>{'  *'}</span>
            </label>
          ) : <React.Fragment />}
          <PRZSelect
            mode={isMultiple ? 'multiple' : ''}
            value={selectedTags}
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            filterOption={false}
            disabled={getDataSourceLoading() && disabled}
            loading={loading}
            onChange={(value) => {
              onChange(value);
            }}
            onSearch={(input) => {
              setNewTagName(input);
              setSearchKeyword(input);
            }}
            placeholder="Select Labels"
            style={customStyle || {
              border: hideCSS ? '' : '1px solid rgba(68, 130, 218, 0.2)',
              height: '28px',
            }}
            className={inputClassName || ' input'}
            allowClear
            maxTagCount={maxTagCount}
          >
            {getDataSource() && getDataSource()?.data?.map((item, index) => (
              <Option key={index} value={item}>
                {item}
              </Option>
            ))}
          </PRZSelect>
        </div>
      ) : (
        <div className={isForm ? containerWrapper : "view-add-tags__wrapper"}>
          {!hideTitle && (<H3Text text="Labels" className="add-tags-title " />)}
          <div style={{ marginTop: isForm ? '0px' : '10px' }}>
            <Fragment>
              <PRZSelect
                mode={isMultiple ? 'multiple' : ''}
                value={selectedTags}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                filterOption={false}
                loading={loading}
                disabled={getDataSourceLoading() && disabled}
                onChange={(value) => {
                  onChange(value);
                }}
                onSearch={(input) => {
                  setNewTagName(input);
                  setSearchKeyword(input);
                }}
                onSelect={(value) => {
                  if (!isForm) {
                    handleOnTagChange('ADD', value);
                  }
                }}
                onDeselect={(value) => {
                  if (!isForm) {
                    handleOnTagChange('REMOVE', value);
                  }
                }}
                showSearch
                placeholder="Select label"
                style={{
                  border: hideCSS ? '' : '1px solid rgba(68, 130, 218, 0.2)',
                  borderRadius: '4px',
                  width: '100%',
                  fontSize: '13px',
                }}
                maxTagCount="responsive"
              >
                {getDataSource() && (
                  !getDataSource()?.data?.filter((item) => (searchKeyword ? item?.toUpperCase()?.includes(searchKeyword?.toUpperCase()) : true))?.length && (
                    <Option key="HIMANSHU" value={searchKeyword}>
                      <div
                        onClick={() => {
                          if (!isForm && selectedTags?.map((item) => item?.toLowerCase())?.includes(newTagName?.toLowerCase())) {
                            notification.open({
                              type: 'warning',
                              message: 'This label is already created',
                              duration: 4,
                              placement: 'top',
                            });
                          } else if (!selectedTags?.map((item) => item?.toLowerCase())?.includes(newTagName?.toLowerCase())
                            && !getDataSourceLoading() && newTagName) {
                            if (!isForm) {
                              handleOnTagChange('ADD', newTagName);
                            } else {
                              onChange(newTagName)
                              setCall(!call)
                            }
                          }
                        }}
                      >
                        {!isForm ? ((getDataSourceLoading() || createTagLoading) ? '' : `Add New "${searchKeyword}"`) : `${searchKeyword}`}
                      </div>
                    </Option>
                  )
                )}

                {getDataSource() && getDataSource()?.data?.map((item, index) => (
                  <Option key={index} value={item}>
                    {item}
                  </Option>
                ))}
              </PRZSelect>
            </Fragment>
          </div>
        </div>
      )}
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, TagReducers }) => ({
  user: UserReducers.user,
  tagsSO: TagReducers.tagsSO,
  tagsInvoice: TagReducers.tagsInvoice,
  tagsPO: TagReducers.tagsPO,
  tagsGRN: TagReducers.tagsGRN,
  getTagsSOLoading: TagReducers.getTagsSOLoading,
  createTagLoading: TagReducers.createTagLoading,
  getTagsInvoiceLoading: TagReducers.getTagsInvoiceLoading,
  getTagsPOLoading: TagReducers.getTagsPOLoading,
  getTagsGRNLoading: TagReducers.getTagsGRNLoading,
  getTagsPRLoading: TagReducers.getTagsPRLoading,
  getTagsPILoading: TagReducers.getTagsPILoading,
  apInvoiceLoading: TagReducers.apInvoiceLoading,
  tagsPR: TagReducers.tagsPR,
  tagsPI: TagReducers.tagsPI,
  apInvoice: TagReducers.apInvoice,
});

const mapDispatchToProps = (dispatch) => ({
  createTag: (payload, callback) => dispatch(TagActions.createTag(payload, callback)),
  getTags: (entityName, page, limit, searchKeyword, callback) => dispatch(TagActions.getTags(entityName, page, limit, searchKeyword, callback)),
});

TagSelector.propTypes = {
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  title: PropTypes.any,
  hideTitle: PropTypes.bool,
  containerClassName: PropTypes.any,
  inputClassName: PropTypes.any,
  labelClassName: PropTypes.string,
  customStyle: PropTypes.any,
  selectedTags: PropTypes.any,
  createTagLoading: PropTypes.bool,
  isMultiple: PropTypes.bool,
  getTagsSOLoading: PropTypes.bool,
  getTagsInvoiceLoading: PropTypes.bool,
  getTags: PropTypes.func,
  createTag: PropTypes.func,
  tagsSO: PropTypes.any,
  tagsInvoice: PropTypes.any,
  entityId: PropTypes.any,
  entityType: PropTypes.any,
  filter: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TagSelector));
